import cx from 'classnames'

import CheckBox from 'shared-web/src/components/CheckBox'
import UISelect from 'components/shared/UISelect'
import { ToolTip } from '@driftt/tide-core-legacy'

import Keyword from '../../Keyword'

import BotFollowUp from '../botFollowUp'
import style from '../style.styl'

const StandardAnswerBody = ({
  answer: { buttonText, keywords },
  isKeywords,
  hasSpecialKeyword,
  onButtonTextChange,
  onClickKeywordsType,
  onClickButtonType,
  onAddYesKeywordClick,
  onAddNoKeywordClick,
  onAddGenericKeywordClick,
  isFlagged,
  onFlagClick,
  skipToOptions,
  currentSkipToOption,
  onSkipToChange,
  botFollowUpProps,
  buttonOnlyResponses,
}) => {
  return (
    <div className={style.AnswerModalContent}>
      <div className="drift-form">
        <strong>Trigger this Follow Up</strong>
        <p>
          Allow users to trigger this follow up by typing a response (Keywords) or by clicking a
          button.
        </p>
        <fieldset className="drift-pill-set">
          <button
            className={cx('drift-button', 'large', { selected: !isKeywords })}
            onClick={onClickButtonType}
          >
            Button
          </button>
          {!!buttonOnlyResponses ?
            <ToolTip
              component="Only button responses are available for this question. Change in Advanced Settings"
              className="playbook-answer-modal-keyword-tooltip-wrapper"
              flow="up"
            >
              <button
                className={cx('drift-button', 'large', { selected: isKeywords })}
                onClick={onClickKeywordsType}
                disabled={buttonOnlyResponses}
              >
                Keywords
              </button>
            </ToolTip>
          :
            <button
              className={cx('drift-button', 'large', { selected: isKeywords })}
              onClick={onClickKeywordsType}
              disabled={buttonOnlyResponses}
            >
              Keywords
            </button>
          }
        </fieldset>
      </div>
      {isKeywords ? (
        <div className="keywords-section drift-form">
          <strong>Keywords</strong>
          <p>
            We recommend adding at least 4 or 5 keywords or phrases to help the bot respond more
            accurately.
          </p>
          {keywords.map(id => <Keyword key={id} id={id} />)}
          <button
            className="drift-button drift-button-secondary"
            onClick={onAddGenericKeywordClick}
          >
            + New Keyword
          </button>
          {!hasSpecialKeyword && (
            <button className="drift-button drift-button-secondary" onClick={onAddYesKeywordClick}>
              + Yes
            </button>
          )}
          {!hasSpecialKeyword && (
            <button className="drift-button drift-button-secondary" onClick={onAddNoKeywordClick}>
              + No
            </button>
          )}
        </div>
      ) : (
        <div className="drift-form">
          <strong>Enter Button Text</strong>
          <p>
            We recommend you keep it short and sweet. Especially if you plan on having multiple
            buttons per question.
          </p>
          <input
            type="text"
            value={buttonText}
            placeholder="Enter text..."
            onChange={onButtonTextChange}
          />
        </div>
      )}
      <BotFollowUp
        showFollowUpPrompt={true}
        {...botFollowUpProps}
      />
      <div className="flag-section">
        <strong>Flag as Default Follow Up</strong>
        <div className="flex">
          <CheckBox onChange={onFlagClick} checked={isFlagged} id="answer-flagged" />
          <p>This follow up will send if no other follow ups match.</p>
        </div>
      </div>
      <div className="drift-form">
        <strong>Next Step</strong>
        <p>
          If user matches this follow up, end the conversation or skip them to a different question
          or goal. You can only skip ahead.
        </p>
        <UISelect
          className="skip-select"
          options={skipToOptions}
          clearable
          value={currentSkipToOption}
          onChange={onSkipToChange}
        />
      </div>
    </div>
  )
}

export default StandardAnswerBody



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/AnswerModalStandardBody/component.js